import moment from 'moment'

/**
 * PR/GCPR technical approver slots carry their own attached delegationDetail
 * (populated by getOffer.service.ts), unlike Quotation/Booking which re-derive
 * an active delegation by cross-matching the separate Delegations list against
 * cost center + delegator name. Reusing the already-attached delegationDetail
 * is simpler and authoritative here, so this mirrors the "Delegated to X from
 * D1 to D2" remark those tables show without redoing that cross-match.
 */
export const getDelegationRemark = (delegationDetail, allUsers) => {
  if (!delegationDetail || typeof delegationDetail !== 'object') {
    return { delegationRemark: '', isEffective: true }
  }

  const delegateeId = delegationDetail?.delegatee?._id || delegationDetail?.delegatee
  const resolvedDelegatee = Array.isArray(allUsers) ? allUsers.find((u) => u._id === delegateeId) : undefined
  const delegateeName = delegationDetail?.delegatee?.fullName || resolvedDelegatee?.fullName || ''

  if (!delegateeName) {
    return { delegationRemark: '', isEffective: true }
  }

  const { validStartDate, validEndDate } = delegationDetail
  const hasValidRange = validStartDate && validEndDate

  return {
    delegationRemark: hasValidRange
      ? `Delegated to ${delegateeName} from ${moment(validStartDate).format('DD-MMM-YYYY')} to ${moment(validEndDate).format('DD-MMM-YYYY')}`
      : `Delegated to ${delegateeName}`,
    isEffective: hasValidRange ? moment().isBetween(validStartDate, validEndDate, 'day', '[]') : true,
  }
}
